import React, { createContext, useContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

type MediaContextType = {
  isTablet: boolean;
  isMobile600: boolean;
  isMobile400: boolean;
};

const MediaContext = createContext<MediaContextType | undefined>(undefined);

export const MediaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const theme = useTheme();

  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile600 = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile400 = useMediaQuery("(max-width:400px)");
  return (
    <MediaContext.Provider value={{ isTablet, isMobile600, isMobile400 }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = (): MediaContextType => {
  const context = useContext(MediaContext);
  if (!context) {
    throw new Error("useMedia must be used within a MediaProvider");
  }
  return context;
};
